import { _ as __rest, a as __assign } from './_tslib-4c7d6ae2.js';
import * as React from 'react';
import LazyLoad from 'react-lazy-load';
import { I as ImageBlur } from './ImageBlur-39da387d.js';

var Image = function (_a) {
    var src = _a.src, _b = _a.cssClass, cssClass = _b === void 0 ? "" : _b, _c = _a.threshold, threshold = _c === void 0 ? 100 : _c, _d = _a.useLazyLoad, useLazyLoad = _d === void 0 ? false : _d, _e = _a.alt, alt = _e === void 0 ? "Tiendeo" : _e, _f = _a.loadingImageURL, loadingImageURL = _f === void 0 ? "" : _f, _g = _a.fullWidth, fullWidth = _g === void 0 ? false : _g, rest = __rest(_a, ["src", "cssClass", "threshold", "useLazyLoad", "alt", "loadingImageURL", "fullWidth"]);
    if (useLazyLoad) {
        return (React.createElement(LazyLoad, { width: fullWidth ? "100%" : undefined, threshold: threshold, debounce: false },
            React.createElement(ImageBlur, __assign({ src: src, className: cssClass, alt: alt, lowResolutionSrc: loadingImageURL, fullWidth: fullWidth }, rest))));
    }
    else {
        return (React.createElement(ImageBlur, __assign({ className: cssClass, src: src, alt: alt, lowResolutionSrc: loadingImageURL, fullWidth: fullWidth }, rest)));
    }
};

export { Image as I };
//# sourceMappingURL=Image-66bee1b2.js.map
